<nb-card class="mobile-faktury-dialog">
  <nb-card-header class="dialog-header">
    <h6>{{ 'tytul.faktury-2-plus-1' | translate }}</h6>
    <button nbButton ghost size="small" (click)="close()" class="close-button">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  
  <nb-card-body class="dialog-body">
    <div *ngIf="loading" class="loading-container">
      <nb-spinner size="medium"></nb-spinner>
      <p>{{ 'etykieta.ladowanie' | translate }}...</p>
    </div>
    
    <div *ngIf="!loading && dane && dane.length === 0" class="no-data-container">
      <nb-icon icon="checkmark-circle-outline" class="success-icon"></nb-icon>
      <p>{{ 'komunikat.brak-niezaplaconych-faktur' | translate }}</p>
    </div>
    
    <div *ngIf="!loading && dane && dane.length > 0">
      <ngx-simple-platnosci-table [dane]="dane"></ngx-simple-platnosci-table>
    </div>
  </nb-card-body>
</nb-card>